import React from 'react';
import { translate } from 'react-i18next';
import {Link} from 'react-router-dom';
import {Header, Message} from 'semantic-ui-react';

import doodle from 'img/verified-email.png';
import {colors, fontSizes, fonts, spacings, layout, buttons} from 'style';

var style = {
    content: {
        paddingTop: '100px',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        maxWidth: '400px',
    },
    title: {
        color: colors.themeBlue,
        ...fonts.h4,
    },
    text: {
        lineHeight: '1.5',
        padding: spacings.base,
        ...fonts.bodyL,
    },
    link: {
        ...buttons.base,
        ...fonts.bodyL,
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: '49px',
        lineHeight: '49px',
    },
    image: {
        width: '200px',
    }
};

const EmailVerified = ({t, params}) => (
    <div style={style.content}>
        <div style={style.title}>{t('Email-Verified!')}</div>
        <br/>
        <img style={style.image} src={doodle} />
        <div style={style.text}>{t('email-verified-text')}</div>
        {/* <a href="https://link.myoptimity.com" style={style.link}>{t('Go to Optimity')}</a> */}
    </div>  
);

export default translate('settings')(EmailVerified);



// WEBPACK FOOTER //
// ./src/modules/settings/EmailVerified.js